// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Reporting: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 50"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M52 46.6H3.4V2C3.4 1.2 2.8.6 2 .6S.6 1.2.6 2v46c0 .8.6 1.4 1.4 1.4h50c.8 0 1.4-.6 1.4-1.4s-.6-1.4-1.4-1.4z"/><path d="M9 44.4h6c.8 0 1.4-.6 1.4-1.4V28c0-.8-.6-1.4-1.4-1.4H9c-.8 0-1.4.6-1.4 1.4v15c0 .8.6 1.4 1.4 1.4zm1.4-15h3.2v12.2h-3.2V29.4zm20.6 15h6c.8 0 1.4-.6 1.4-1.4V21c0-.8-.6-1.4-1.4-1.4h-6c-.8 0-1.4.6-1.4 1.4v22c0 .8.6 1.4 1.4 1.4zm1.4-22h3.2v19.2h-3.2V22.4zM20 44.4h6c.8 0 1.4-.6 1.4-1.4V11c0-.8-.6-1.4-1.4-1.4h-6c-.8 0-1.4.6-1.4 1.4v32c0 .8.6 1.4 1.4 1.4zm1.4-32h3.2v29.2h-3.2V12.4zm20.6 32h6c.8 0 1.4-.6 1.4-1.4v-7c0-.8-.6-1.4-1.4-1.4h-6c-.8 0-1.4.6-1.4 1.4v7c0 .8.6 1.4 1.4 1.4zm1.4-7h3.2v4.2h-3.2v-4.2z"/></svg>;
};

export default React.memo(Reporting);
